import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=0d8a987c&scoped=true"
import script from "./Defects.vue?vue&type=script&lang=js"
export * from "./Defects.vue?vue&type=script&lang=js"
import style0 from "./Defects.vue?vue&type=style&index=0&id=0d8a987c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a987c",
  null
  
)

export default component.exports